import { GameState, GamePhase } from '../types'
import * as gameLogic from './gameLogic'

export type AgentKind = 'humanLocal' | 'humanRemote' | 'ai'
export type PlayMode = 'SINGLE_PLAYER' | 'MULTIPLAYER_PVP'

export interface Agent {
  kind: AgentKind
  nextAction: (state: GameState) => Promise<gameLogic.AIAction | null>
}

export const createAIAgent = (): Agent => {
  return {
    kind: 'ai',
    nextAction: async (state: GameState) => {
      return gameLogic.getBestAIAction(state)
    },
  }
}

export const createHumanLocalAgent = (): Agent => {
  return {
    kind: 'humanLocal',
    nextAction: async () => null,
  }
}

export const createHumanRemoteAgent = (): Agent => {
  return {
    kind: 'humanRemote',
    nextAction: async () => null,
  }
}

export const getAgentMap = (
  state: GameState,
  playMode: PlayMode,
  localPlayerId: number,
): Record<number, Agent> => {
  const otherId = localPlayerId === 1 ? 2 : 1
  if (playMode === 'SINGLE_PLAYER') {
    return {
      [localPlayerId]: createHumanLocalAgent(),
      [otherId]: createAIAgent(),
    }
  }
  return {
    [localPlayerId]: createHumanLocalAgent(),
    [otherId]: createHumanRemoteAgent(),
  }
}

export const isAgentTurnToAct = (
  state: GameState,
  playerId: number,
): boolean => {
  if (state.phase === GamePhase.GameOver) return false;
  const player = state.players.find(p => p.id === playerId);
  if (player && player.health <= 0) return false;

  // Use lastCardPlayerId as the source of truth for turn order during activations
  const hasActiveActivation = state.activations.some(act => !act.resolved && !act.accepted);
  if (hasActiveActivation) {
    // It's this player's turn if the OTHER player played the last card
    return state.lastCardPlayerId !== undefined && state.lastCardPlayerId !== playerId;
  }
  return state.turnPlayerId === playerId;
}
